import { useSearchParams } from "react-router-dom";
import { QRCodeCanvas } from "qrcode.react";
import { useRef } from "react";

const PageQRCode = () => {
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code") || "NO_CODE";

  const qrRef = useRef(null); // QR yang ditampilkan (250px)

  const downloadQR = () => {
    const qrCanvas = qrRef.current.querySelector("canvas");
    const qrSize = 500;
    const textHeight = 80;
    const totalHeight = qrSize + textHeight;

    // Ambil QR dalam resolusi tinggi
    const img = new Image();
    img.src = qrCanvas.toDataURL("image/png");

    img.onload = () => {
      const finalCanvas = document.createElement("canvas");
      finalCanvas.width = qrSize;
      finalCanvas.height = totalHeight;

      const ctx = finalCanvas.getContext("2d");

      // Background putih
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, qrSize, totalHeight);

      // Draw QR
      ctx.drawImage(img, 0, 0, qrSize, qrSize);

      // Text below QR
      ctx.fillStyle = "#000000";
      ctx.font = "bold 40px Arial";
      ctx.textAlign = "center";
      ctx.fillText(code, qrSize / 2, qrSize + 55);

      const pngUrl = finalCanvas.toDataURL("image/png").replace("image/png", "image/octet-stream");

      const link = document.createElement("a");
      link.href = pngUrl;
      link.download = `${code}.png`;
      link.click();
    };
  };

  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-gray-100 p-0">
      <h1 className="text-xl font-semibold mb-6 text-gray-800">
        QR Code
      </h1>

      {/* QR ditampilkan */}
      <div ref={qrRef} className="p-0 bg-white rounded-xl shadow-lg">
        <QRCodeCanvas value={code} size={250} includeMargin={true} />
      </div>

      {/* Text tampil di halaman */}
      <p className="mt-4 text-gray-700 font-bold text-lg tracking-widest">
        {code}
      </p>

      <button
        onClick={downloadQR}
        className="mt-6 px-6 py-3 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700 transition"
      >
        Download QR Code
      </button>
    </div>
  );
};

export default PageQRCode;
